import React, { useRef, useState } from "react";

const AudioRecorder = ({
  tone,
  onRecordingComplete,
  recordedAudioURL,
  setRecordedAudioURL,
  isRecordedAudioEnabled,
  setIsRecordedAudioEnabled,
}) => {
  const [recording, setRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const audioRef = useRef(null);

  const toggleRecording = async () => {
    if (recording) {
      mediaRecorder.stop();
      setRecording(false);
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const recorder = new MediaRecorder(stream);
        const audioChunks = [];

        recorder.ondataavailable = (event) => {
          audioChunks.push(event.data);
        };

        recorder.onstop = async () => {
          const audioBlob = new Blob(audioChunks, {
            type: "audio/ogg; codecs=opus",
          });
          const audioURL = URL.createObjectURL(audioBlob);

          setRecordedAudioURL(audioURL);
          setIsRecordedAudioEnabled(true);

          // Decode audio and resample to 16 kHz
          const arrayBuffer = await audioBlob.arrayBuffer();
          const audioContext = new AudioContext();
          const originalAudioBuffer = await audioContext.decodeAudioData(
            arrayBuffer
          );

          const resampledBuffer = await resampleAudioBuffer(
            originalAudioBuffer,
            audioContext,
            16000
          );

          const resampledSamples = resampledBuffer.getChannelData(0); // Assuming mono

          // Send resampled audio data to the server
          fetch("/api/analyze", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              audio_samples: Array.from(resampledSamples),
              sample_rate: 16000,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              onRecordingComplete(data);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        };

        setMediaRecorder(recorder);
        recorder.start();
        setRecording(true);
      } catch (error) {
        console.error("Error accessing microphone:", error);
        alert("Unable to access microphone: " + error.message);
      }
    }
  };

  const resampleAudioBuffer = async (
    audioBuffer,
    audioContext,
    targetSampleRate
  ) => {
    const offlineContext = new OfflineAudioContext(
      audioBuffer.numberOfChannels,
      (audioBuffer.length * targetSampleRate) / audioBuffer.sampleRate,
      targetSampleRate
    );

    const bufferSource = offlineContext.createBufferSource();
    bufferSource.buffer = audioBuffer;

    bufferSource.connect(offlineContext.destination);
    bufferSource.start(0);

    return await offlineContext.startRendering();
  };

  const playRecordedAudio = () => {
    if (recordedAudioURL) {
      audioRef.current.src = recordedAudioURL;
      audioRef.current.play();
    }
  };

  return (
    <div>
      <button onClick={toggleRecording}>
        {recording ? "Stop Recording" : "Start Recording"}
      </button>

      <button onClick={playRecordedAudio} disabled={!isRecordedAudioEnabled}>
        Play Recorded Audio
      </button>

      <audio ref={audioRef} controls hidden />
    </div>
  );
};

export default AudioRecorder;
